import { Avatar, Box, Grid } from "@mui/material";
import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import QueryPageTitleCard from "../../components/QueryPageTitleCard/QueryPageTitleCard";
import CustomCard from "../../components/CustomCard/CustomCard";
import CardTitleWithSubtitle from "../../components/CardTitleWithSubtitle/CardTitleWithSubtitle";
import CustomTabs from "../../components/CustomTabs/CustomTabs";
import DetailedStatementTableSection from "./Sections/DetailedStatementTableSection";
import SummaryStatementTableSection from "./Sections/SummaryStatementTableSection";
import ButtonFilterTableSection from "./Sections/ButtonFilterTableSection";
import CardDataNotFound from "../../components/CardDataNotFound/CardDataNotFound";

const ConsultQuoteStatementPage: React.FC = () => {
  const [filter, setFilter] = useState<any | null>(null);
  const [isClear, setClear] = useState<boolean>(false);

  return (
    <Layout
      enableMargin
      appBarProps={{
        notification: {
          onChange() {},
        },
        chat: {
          onChange() {},
        },
        settings: {
          onChange() {},
        },
        avatar: () => (
          <Avatar
            alt="Avatar"
            src="/images/avatar.png"
            sx={{
              width: 60,
              height: 60,
            }}
          />
        ),
      }}
    >
      <Grid item xs={12}>
        <QueryPageTitleCard title="Extrato de cota" />
      </Grid>
      <Grid item xs={12} sx={{ marginTop: "24px" }}>
        <CustomCard
          sx={{
            boxShadow: "none",
            border: "1px solid #DFE0EB",
            height: "100%",
            padding: 2.4,
          }}
        >
          <CardTitleWithSubtitle
            title="Consultar extrato de Cota"
            subtitle="Informe os parâmetros de pesquisa para consultar o saldo. As informações estão disponíveis para um período máximo de 5 anos."
          />
          <ButtonFilterTableSection
            onButtonChange={(value) => {
              setFilter(value);
            }}
            onButtonClearFilter={(value) => {
              setClear(value);
              setFilter(null);
            }}
          />

          {!filter ? (
            <Box alignSelf={"center"} mt={2}>
              <CardDataNotFound
                icon="search-empty"
                title="Selecione o CNPJ, Período, Produto e Modalidade."
                subtitle="Informe outros critérios de busca e comece a consultar!"
              />
            </Box>
          ) : (
            <CustomTabs
              tabsHeader={["Extrato detalhado", "Extrato resumido"]}
              body={[
                <DetailedStatementTableSection
                  key={1}
                  dataFilter={filter}
                  isClear={isClear}
                />,
                <SummaryStatementTableSection
                  key={2}
                  dataFilter={filter}
                  isClear={isClear}
                />,
              ]}
            />
          )}
        </CustomCard>
      </Grid>
    </Layout>
  );
};

export default ConsultQuoteStatementPage;
